// extracted by mini-css-extract-plugin
export default {"preview-container":"WidgetPreview_preview-container__FQoSG","preview-text-container":"WidgetPreview_preview-text-container__xiBM4"};